import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.SituationCategory;

export const statusSelector = createSelector(rootSelector, (situationCategory) => situationCategory.status);

export const errorSelector = createSelector(rootSelector, (situationCategory) => situationCategory.error);

const situationCategorySelector = createSelector(rootSelector, (situationCategory) => situationCategory.data);

export const situationCategoryById = createSelector(
  situationCategorySelector,
  (data) => (id: number) => data && data.find((dataItem) => dataItem.id === id)
);

export default {
  statusSelector,
  errorSelector,
  situationCategorySelector,
  situationCategoryById,
};
